import React from 'react'

interface AnalyticsIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const AnalyticsIcon: React.FC<AnalyticsIconProps> = ({
  color = '#888',
  gradient,
  width = 24,
  height = 28,
  alt = 'Analytics icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 28'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M19.956 3.548a.9.9 0 100-1.798.9.9 0 000 1.798zm2.4-.899a2.4 2.4 0 01-3.204 2.261l-4.6 4.6a2.4 2.4 0 01-3.838 2.274L5.87 12.856a2.4 2.4 0 11-.556-1.413l4.534-1.004a2.4 2.4 0 013.966-2.312L17.96 3.98a2.4 2.4 0 114.395-1.331zm-9.274 7.237a.9.9 0 11-1.798 0 .9.9 0 011.798 0zm-8.709 3.097a.9.9 0 11-1.798 0 .9.9 0 011.798 0zM21.439 9.76c.967 0 1.75.784 1.75 1.75V27.75h-6.447V11.51c0-.967.784-1.75 1.75-1.75h2.947zm.25 1.75a.25.25 0 00-.25-.25h-2.947a.25.25 0 00-.25.25V26.25h3.447V11.51zm-6.748 6.597a1.75 1.75 0 00-1.75-1.75h-2.947a1.75 1.75 0 00-1.75 1.75v9.644h6.447v-9.644zm-1.75-.25a.25.25 0 01.25.25v8.144H9.994v-8.144a.25.25 0 01.25-.25h2.947zm-8.244 1.799c.967 0 1.75.783 1.75 1.75v6.346H.25v-6.346c0-.967.783-1.75 1.75-1.75h2.947zm.25 1.75a.25.25 0 00-.25-.25H2a.25.25 0 00-.25.25v4.846h3.447v-4.846z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default AnalyticsIcon
